export const START_LOAD = 'START_LOAD'
export const STOP_LOAD = 'STOP_LOAD'
export const CATCH_ERRORS = 'CATCH_ERRORS'
export const REFRESH_ERRORS = 'REFRESH_ERRORS'
export const SET_OPEN_UPDATE_PHONE_MODAL = 'SET_OPEN_UPDATE_PHONE_MODAL'
